import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShield: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShield"><Path d="M12 1.94238L3 5.03613V11.9122C3 14.7189 4.14891 16.7416 5.8125 18.3166C7.38493 19.8053 9.44484 20.916 11.3681 21.9531L12 22.294L12.6319 21.9531C14.5552 20.916 16.6151 19.8052 18.1875 18.3166C19.8511 16.7416 21 14.7189 21 11.9122V5.03613L12 1.94238Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShield;
